import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "../components/Home";
import Disclaimer from "../components/Disclaimer";
// import About from '../components/About/About';
import { ApiProvider } from "../context/apiContext";
import "../styles/base.css";
import "./styles.css";
import disclaimerConfig from "../config/disclaimerConfig";

const RouterDOM = () => {
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  // Check if disclaimer has been accepted on component mount
  useEffect(() => {
    const hasAccepted = sessionStorage.getItem(disclaimerConfig.storageKey);
    setDisclaimerAccepted(hasAccepted === "true");
  }, []);

  // Determine the initial API type based on the path
  const determineApiType = () => {
    const path = window.location.pathname;
    if (path.startsWith("/v1")) return "databricks";
    if (path.startsWith("/v2")) return "postgres";
    return "postgres"; // Default to Databricks if path is not specified
  };

  const initialApiType = determineApiType();

  const handleDisclaimerAccept = () => {
    try {
      sessionStorage.setItem(disclaimerConfig.storageKey, "true");
      setDisclaimerAccepted(true);
    } catch (error) {
      console.error(
        "Failed to save disclaimer acceptance to sessionStorage:",
        error,
      );
      setDisclaimerAccepted(true);
    }
  };

  return (
    <ApiProvider initialApiType={initialApiType}>
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/home">
            <Home />
          </Route>
          {/* <Route exact path="/about"><About /></Route> */}
        </Switch>
        {!disclaimerAccepted && (
          <Disclaimer onAccept={handleDisclaimerAccept} />
        )}
      </Router>
    </ApiProvider>
  );
};
export default RouterDOM;
